'use strict';

DoohApps
.directive('slider', function () {
    return {
        restrict: 'A',
        scope: {
            model: '=',
            stop: '&'
        },
        link: function (scope, element, attrs) {
            element.slider({
                value: scope.model,
                min: parseFloat(attrs.min),
                max: parseFloat(attrs.max),
                step: parseFloat(attrs.step || 1),
                slide: function (event, ui) {
                    scope.$apply(function () {
                        scope.model = ui.value;
                    });
                },
                stop: function (event, ui) {
                    scope.stop();
                }
            });
            scope.$watch(function () {
                return scope.model
            }, function () {
                element.slider({ value: scope.model });
            });
        }
    };
});